var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaurusSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "244px",
    height: "244px",
    viewBox: "0 0 960.00 960.00",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 9.6,
    transform: "rotate(0)matrix(1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 76.8
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1313_6310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.093 430.144C292.335 374.889 281.992 288.844 231.769 219.302C206.259 186.874 165.72 162.647 123.653 174.924C72.178 184.281 63.979 119.3 111.128 104.553C179.266 80.5969 251.304 116.41 293.005 170.387C363.128 257.583 367.671 404.251 513.989 395.822C664.994 366.186 635.365 114.9 835.508 86.1268C882.544 77.9268 899.733 151.174 850.029 164.085C817.241 171.049 789.044 186.027 767.969 211.994C712.307 282.923 688.513 378.322 616.235 435.859C783.114 545.004 707.552 843.465 513.324 870.315C229.507 912.514 153.074 582.13 365.093 430.144ZM631.927 615.636C623.494 518.533 585.067 504.074 501.893 474.904C490.976 474.366 479.843 472.984 468.876 473.057C374.074 475.705 314.945 580.278 320.762 668.314C323.757 725.076 364.798 772.048 417.936 789.122C538.32 826.148 629.105 733.987 631.927 615.636Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1313_6310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800.001,
    height: 790,
    fill: "white",
    transform: "translate(80 85)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaurusSvgrepoCom);
export default __webpack_public_path__ + "static/media/taurus-svgrepo-com.fc460b168d3311bc812c9900437436d0.svg";
export { ForwardRef as ReactComponent };